/**
 * Product Grid Video Handler
 * Handles autoplay and lazy loading for videos in product cards
 */

(function() {
  'use strict';
  
  /**
   * Initialize product grid videos
   * Uses IntersectionObserver for lazy loading and autoplay handling
   */
  function initProductGridVideos() {
    const productVideos = document.querySelectorAll('[data-product-video] video');
    if (productVideos.length === 0) return;
    
    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
      // Fallback: Try to play all videos immediately
      productVideos.forEach(video => {
        if (video.muted) {
          video.play().catch(() => {
            // Autoplay failed, ignore
          });
        }
      });
      return;
    }
    
    // Create observer for lazy loading and autoplay
    const observerOptions = {
      root: null, // viewport
      rootMargin: '50px 0px', // Start loading when 50px away from viewport
      threshold: [0, 0.1] // Trigger when video enters viewport
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        
        if (entry.isIntersecting) {
          // Video is in viewport or approaching
          // Ensure muted for autoplay compliance
          video.muted = true;
          
          // Try to play the video
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              // Playback started successfully
            }).catch(error => {
              // Autoplay failed (usually browser policy)
              console.log('Product grid video autoplay failed:', error);
            });
          }
          
          // Once video starts playing, we can unobserve it
          video.addEventListener('playing', () => {
            observer.unobserve(video);
          }, { once: true });
        }
      });
    }, observerOptions);
    
    // Observe all product grid videos
    productVideos.forEach(video => {
      // Ensure muted for autoplay
      video.muted = true;
      observer.observe(video);
      
      // Handle video error - show fallback image
      video.addEventListener('error', () => {
        const card = video.closest('.card-product__media');
        if (card) {
          const fallback = card.querySelector('.card-product__video-fallback');
          const videoContainer = card.querySelector('.card-product__video');
          if (fallback && videoContainer) {
            videoContainer.style.display = 'none';
            fallback.style.display = 'block';
          }
        }
      }, { once: true });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGridVideos);
  } else {
    initProductGridVideos();
  }
  
  // Re-initialize when new content is loaded (e.g., infinite scroll, filters)
  document.addEventListener('productGridUpdated', initProductGridVideos);
  
})();
